import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-surface-50">
      <Sidebar />
      {/* ml-64 matches sidebar width; on mobile (< lg) sidebar is overlay so no margin */}
      <main className="lg:ml-64 min-h-screen pt-14 lg:pt-0">
        <div className="animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
}
